import { get } from 'lodash'
import { required, requiredPhone, email, phone } from 'utils/validation'

const validate = values => {
  let errors = {}

  errors = {
    email: required(get(values, 'email')) || email(get(values, 'email')),
    phoneNumber:
      requiredPhone(get(values, 'phoneNumber')) ||
      phone(get(values, 'phoneNumber')),
    phoneType: {
      value: required(get(values, 'phoneType.value'))
    },
    emailAgain: required(get(values, 'emailAgain'))
  }

  if (get(values, 'email') && get(values, 'emailAgain')) {
    if (get(values, 'email') !== get(values, 'emailAgain')) {
      errors = {
        ...errors,
        emailAgain: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  }

  return errors
}

export default validate
